import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#172554] text-white px-4 md:px-24 py-6 flex flex-col items-center justify-between text-sm mt-auto border-t-[4px] border-[#F5B800]">
      <div className="w-full flex flex-col md:flex-row items-center justify-between mb-4">
        <div>@2025-All right reserved-Powered by <span className="text-[#F5B800] font-bold">Kagajbook</span></div>
        <div className="flex gap-4 mt-2 md:mt-0">
          <Link to="/policy" className="hover:underline">Policy</Link>
          <span>|</span>
          <Link to="/contact" className="hover:underline">Contact</Link>
        </div>
      </div>
      <div className="w-full text-center text-xs text-white/70 border-t border-white/20 pt-4 mt-2 leading-relaxed">
        Disclaimer: Kagajbook Online is a private, third-party document assistance service and is not affiliated with, endorsed by, or authorized by any government authority.
      </div>
    </footer>
  );
}